import {useEffect, useState} from 'react';

import {installPlotExportButtons} from '../screenshot/plotExportButtons';

/**
 * Custom hook to load Plotly.js asynchronously only when it's needed.
 */
export function usePlotly() {
  const [loaded, setLoaded] = useState(!!window.Plotly);

  useEffect(() => {
    if (window.Plotly) {
      installPlotExportButtons();
      setLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.plot.ly/plotly-3.5.1.min.js';
    script.onload = () => {
      installPlotExportButtons();
      setLoaded(true);
    };
    document.head.appendChild(script);
  }, []);

  return loaded;
}